<div class="content-label-container">
    <ng-container *ngIf="articleCount; else NotFound">
        <h2>{{ "search.result" | translate: {arg0: result | translate, arg1: searchType | translate, arg2: articleCount } }}</h2>
    </ng-container>
</div>

<div class="content-main-container">
    <!-- Search result -->
    <ng-container *ngFor="let article of articles">
        <mat-card class="article-card">
            <mat-card-header (click)="onClick(article.key, article.type)">
                <mat-card-title>
                    <div class="main-title">
                        {{ article.title }}
                    </div>
                    <div *ngIf="article.type === 'search.type_voice'" class="volume">
                    </div>
                    <div *ngIf="article.type === 'search.type_info'" class="prefecture">
                        {{ article.place }}
                    </div>
                </mat-card-title>         
            </mat-card-header>
            <mat-divider></mat-divider>
            <mat-card-content>
                <div fxLayout="row wrap" fxLayoutAlign="start" class="chip_area">
                    <mat-chip-list *ngFor="let tag of article.tags">
                        <mat-chip [ngStyle]="chipStyle(article.type, tag)" (click)="onChipClick(tag)" selected>{{ tag | translate }}</mat-chip>
                    </mat-chip-list>
                </div>
            </mat-card-content>
        </mat-card>
    </ng-container>

    <!-- paginator -->
    <ng-container *ngIf="this.allArticles.length > 5">
        <mat-paginator
            #paginator
            [length]="this.allArticles.length"
            [pageSize]="5"
            [pageIndex]="this.pageIndex"
            (page)="pageEvent($event)"
            hidePageSize="true">
        </mat-paginator>
    </ng-container>
</div>

<ng-template #NotFound>
    <h2>{{ "search.notfound" | translate: {arg0: result | translate, arg1: searchType | translate} }}</h2>
    <div class="goback_btn">
        <button 
            (click)="goBack()"
            mat-raised-button 
            color="primary">
            <mat-icon>arrow_back</mat-icon>
            <span translate>navigation.goback</span>
        </button>
    </div>
</ng-template>